module.exports = __webpack_public_path__ + "static/media/menuIcon.6a40832b.svg";